import moment from "moment";
export function parseOrder(data) {
    var order = data;
    order.created_at = moment(data.created_at);
    order.updated_at = moment(data.updated_at);
    return order;
}
export function blankOrder() {
    return {};
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3JkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJPcmRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE1BQWdCLE1BQU0sUUFBUSxDQUFDO0FBcUV0QyxNQUFNLFVBQVUsVUFBVSxDQUFDLElBQVM7SUFDbEMsSUFBTSxLQUFLLEdBQUcsSUFBYSxDQUFDO0lBQzVCLEtBQUssQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUMzQyxLQUFLLENBQUMsVUFBVSxHQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDNUMsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDO0FBRUQsTUFBTSxVQUFVLFVBQVU7SUFDeEIsT0FBTyxFQUFXLENBQUM7QUFDckIsQ0FBQyJ9